module.exports = __webpack_public_path__ + "static/phoslogo-eccbe08072099dba8e4bb5236d8bb90e.svg";